export const environment = {
   production: false,
   name: 'rc'
};
